exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dv-gesuchsteller .gesuchsteller-title:after{line-height:45px;display:block;margin-top:10px;margin-bottom:24px;border:0;border-top:1px solid #bc2500;content:\"\"}.dv-gesuchsteller .h2-gesuchsteller .h2-prefix{font-size:14px;display:block;margin-bottom:5px;font-weight:400;font-style:italic}.dv-gesuchsteller input[type=number].no-step-arrow{-moz-appearance:textfield}.dv-gesuchsteller input[type=number].no-step-arrow::-webkit-inner-spin-button,.dv-gesuchsteller input[type=number].no-step-arrow::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-gesuchsteller/dv-gesuchsteller.scss
// module id = cg+K
// module chunks = 0